//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SaleCards from './-saleCards.vue';
import { mapGetters } from 'vuex';
import TopSale from '@/components/d0822/components/topSale';

export default {
  components: { SaleCards, TopSale },
  props: {
    namespace: {
      type: String,
      default: null,
    },

    addToBasket: {
      type: Function,
      default: () => {},
    },
    basket: {
      type: Array,
      default: () => [],
    },
    requestCompanyCatalog: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('sale', ['isSaleWithoutPrice', 'isCompanyCatalog']),
    buzy() {
      return (
        this.$store.state.sale.coursesBuzy ||
        this.$store.state.sale.professionsBuzy
      );
    },
    empty() {
      // Если coursesTitle и professionsTitle не пустые
      // значит первая загрузка уже прошла
      return (
        !this.$store.state.sale.professionsTotal &&
        this.$store.state.sale.professionsTitle &&
        !this.$store.state.sale.coursesTotal &&
        this.$store.state.sale.coursesTitle
      );
    },
  },
  methods: {
    sendCompanyCatalogRequest(payload) {
      this.$emit('sendCompanyCatalogRequest', payload);
    },
  },
};
